import * as React from "react";
import "./PanSpinner.css";

export default function PanSpinner() {
  return <span className="panloader"></span>;
}